import styled, { keyframes } from 'styled-components'
import { GRAYSCALE_500, VIOLET_600 } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`

const popIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  70% {
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`

type AnimationType = 'fade' | 'slide' | 'pop';

interface AlertBoxContainerProps {
  $animationDuration?: number;
  $animationType?: AnimationType;
  $backgroundColor?: string;
  $borderColor?: string;
}

interface AlertTextProps {
  $fontFamily?: string;
  $textAlign?: 'left' | 'center' | 'right' | 'justify';
  $fontSize?: React.CSSProperties['fontSize'];
}

const getAnimation = (type: AnimationType = 'fade') => {
  switch (type) {
    case 'slide':
      return slideIn;
    case 'pop':
      return popIn;
    case 'fade':
    default:
      return fadeIn;
  }
};

export const AlertBoxContainer = (styled.div as any)<AlertBoxContainerProps>`
  display: flex;
  width: 100%;
  border: 1px solid ${(props: AlertBoxContainerProps) => props.$borderColor || '#F2AF01'};
  border-radius: 8px;
  background-color: ${(props: AlertBoxContainerProps) => props.$backgroundColor || '#FEFBE2'};
  padding: 16px 12px;
  gap: 8px;
  align-items: flex-start;
  animation: ${(props: AlertBoxContainerProps) => getAnimation(props.$animationType)} ${(props: AlertBoxContainerProps) => props.$animationDuration || 0.3}s ease-in-out;
`

export const IconContainer = styled.div`
  flex-shrink: 0;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const AlertText = (styled.span as any)<AlertTextProps>`
  color: ${GRAYSCALE_500};
  font-family: ${(props: AlertTextProps) => props.$fontFamily || INTER.regular};
  font-size: ${(props: AlertTextProps) => props.$fontSize || '12px'};
  line-height: 16px;
  text-align: ${(props: AlertTextProps) => props.$textAlign || 'left'};
`

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`

export const ActionText = styled.span`
  color: ${VIOLET_600};
  font-family: ${INTER.medium};
  font-size: 12px;
  cursor: pointer;
  margin-top: 1px;
`
